import cl from "classnames";
import { useEffect } from "react";

import cls from "./ProgressBar.module.css";

import { useProgressManager } from "@/shared/lib/useProgressManager";

interface ProgressBarProps {
    className?: string;
}

export const ProgressBar = (props: ProgressBarProps) => {
    const { className } = props;
    const { averageProgress, resetProgress, progresses, shouldShowText } = useProgressManager();

    const allAreDone = progresses.every((progress) => progress === 100 || progress === 0);
    useEffect(() => {
        if (allAreDone) {
            setTimeout(() => {
                resetProgress();
            }, 1000);
        }
    }, [allAreDone]);

    return (
        <div
            className={cl(cls.progressBar, className, { [cls.done]: allAreDone })}
            style={{
                zIndex: !averageProgress ? -1 : 1,
                display: !averageProgress ? "none" : "block",
            }}
        >
            <div
                className={cls.progress}
                style={{
                    width: `${averageProgress}%`,
                }}
            />
            {shouldShowText && (
                <span className={cls.text}>Don't reload the page, while data is uploading</span>
            )}
        </div>
    );
};
